// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aTbb","colMin":"styles_colMin__26n_8"};